import { MouseEvent } from 'react';
import SettingsIcon from '@mui/icons-material/SettingsTwoTone';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useAppDispatch } from '@reduxStore';
import { queueModal } from '@components/Modals/modalSlice';
import { useFetchMyProfileQuery } from '@api/Trinium/Endpoints/myProfile';
import { AvatarMenuItemProps } from './types';

export default function TerminalPreferencesMenuItem({ textClassName, ...props }: AvatarMenuItemProps<HTMLElement>) {
  const appDispatch = useAppDispatch();
  const { data: user } = useFetchMyProfileQuery(undefined);

  if (!user?.canEditTerminalPreferences) return null;

  const clickHandler = (event: MouseEvent<HTMLElement>) => {
    appDispatch(queueModal({ Component: 'terminalPreferences' }));
    props.onClick?.(event);
  };

  return (
    <MenuItem
      className={props.className}
      onClick={clickHandler}>
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText slotProps={{ primary: { className: textClassName } }}>Terminal Preferences</ListItemText>
    </MenuItem>
  );
}
